import { Grid } from "@material-ui/core"
import { Button } from "@funcional/react-ui"
import * as yup from "yup"
import { UseFormGetValues } from "react-hook-form"
import { useHistory } from "react-router-dom"
import { useState } from "react"

export interface IMultiStepFormButtonPartial extends Partial<IMultiStepFormButton> {}

export interface IMultiStepFormButton {
  currentStepIndex: number
  setCurrentStepIndex: React.Dispatch<React.SetStateAction<number>>
  stepsIndexesArray: Array<number>
  generateSubmitButton?: boolean
  generateExitButton?: boolean
  buttonCustomize? : IButtonCustomize
}

export interface IButtonCustomize {
  exitButtonCustomize?: IButton
  backButtonCustomize?: IButtonBackAndForward
  forwardButtonCustomize?: IButtonBackAndForward
  submitButtonCustomize?: IButtonSubmit
  formDataValues: UseFormGetValues<any>
}

export interface IButton {
  isDisabled?: boolean
}
export interface IButtonBackAndForward extends IButton {
  yupSchemaValidationArray?: Array<yup.AnySchema>
}
export interface IButtonSubmit extends IButton {
  yupSchemaValidationConcatened?: yup.AnySchema
}

export function MultiStepFormButton({ props } : { props: IMultiStepFormButton }): JSX.Element {
  const firstStep: boolean = (props.currentStepIndex === props.stepsIndexesArray[0]);
  const lastStep: boolean = (props.currentStepIndex === props.stepsIndexesArray[props.stepsIndexesArray.length - 1]);
  const history = useHistory();   
  const [forwardButtonHover, setForwardButtonHover] = useState(false);
  const [backButtonHover, setBackButtonHover] = useState(false);

  function isButtonDisabled(buttonCustomize?): boolean {
    return (buttonCustomize?.isDisabled) ? buttonCustomize.isDisabled : false;
  } 

  function getBackAndForwardButtonStyle(isHover: boolean, buttonCustomize?) {
    const _ = {
      style: {}
    }
    const disabled = isBackAndForwardButtonDisabled(buttonCustomize)
    if (disabled) {
      _.style = {
      }
    } else if (isHover) {
      _.style = {
        backgroundColor: "rgba(229, 231, 235, var(--tw-bg-opacity))",
        color: "black",
        borderColor: "rgba(229, 231, 235, var(--tw-bg-opacity))",
      }
    } else {
      _.style = {
        backgroundColor: "rgba(209, 213, 219, var(--tw-bg-opacity))",
        color: "black",
        borderColor: "rgba(209, 213, 219, var(--tw-bg-opacity))",
      }
    }
    return _
  }

  function isBackAndForwardButtonDisabled(buttonCustomize?): boolean {
    if (buttonCustomize?.yupSchemaValidationArray?.length > 0) {
      const validationArray = buttonCustomize.yupSchemaValidationArray;
      const validationSchema = validationArray[props.currentStepIndex];
      return (validationSchema && props.buttonCustomize?.formDataValues && !validationSchema.isValidSync(props.buttonCustomize.formDataValues())) || isButtonDisabled(buttonCustomize);
    }
    return false || isButtonDisabled(buttonCustomize)
  }
  
  function submitButtonValidation(buttonCustomize?): boolean {
    if (buttonCustomize?.yupSchemaValidationConcatened) {
      const validationSchema = buttonCustomize.yupSchemaValidationConcatened;
      return (validationSchema && props.buttonCustomize?.formDataValues && !validationSchema.isValidSync(props.buttonCustomize.formDataValues()));
    }
    return false
  }

  function next() {
    props.setCurrentStepIndex(i => {
      let nextIndex = i+1
      if (props.stepsIndexesArray.includes(nextIndex)) {
        return nextIndex
      } else {
        nextIndex = props.stepsIndexesArray.findIndex(index => index > nextIndex)
        return props.stepsIndexesArray[nextIndex]
      }
    })
  }

  function back() {
    props.setCurrentStepIndex(i => {
      let previousIndex = i-1
      if (props.stepsIndexesArray.includes(previousIndex)) {
        return previousIndex
      } else {
        previousIndex = props.stepsIndexesArray.findIndex(index => index < previousIndex)
        return props.stepsIndexesArray[previousIndex]
      }
    })
  }
  
  return ( 
    <Grid item xs={12}>
      { firstStep && props.generateExitButton &&
        <div className="float-left mt-3">
          <Button 
            onClick={() => history.goBack()}
            type="button"
            disabled={isButtonDisabled(props.buttonCustomize?.exitButtonCustomize)}
            color="danger"
          >
            Sair
          </Button>
        </div>
      }
      { !firstStep && 
        <div className="float-left mt-3">
          <Button 
            {...getBackAndForwardButtonStyle(backButtonHover, props.buttonCustomize?.backButtonCustomize)}
            onMouseEnter={() => setBackButtonHover(true)}
            onMouseLeave={() => setBackButtonHover(false)}
            disabled={isBackAndForwardButtonDisabled(props.buttonCustomize?.backButtonCustomize)}
            onClick={() => { back(); setBackButtonHover(false);}}
            type="button"
          >
            Voltar
          </Button>
        </div>
      }
      { !lastStep && 
          <div className="float-right mt-3">
            <Button 
              {...getBackAndForwardButtonStyle(forwardButtonHover, props.buttonCustomize?.forwardButtonCustomize)}
              onMouseEnter={() => setForwardButtonHover(true)}
              onMouseLeave={() => setForwardButtonHover(false)}
              disabled={isBackAndForwardButtonDisabled(props.buttonCustomize?.forwardButtonCustomize)}
              onClick={() => { next(); setForwardButtonHover(false);}}
              type="button" 
            >
              Avançar
            </Button> 
          </div>  
      }
      { lastStep && props.generateSubmitButton &&
        <div className="float-right mt-3">
          <Button 
            type="submit" 
            disabled={isButtonDisabled(props.buttonCustomize?.submitButtonCustomize) || submitButtonValidation(props.buttonCustomize?.submitButtonCustomize)} 
            color="primary"
          >
            Salvar
          </Button>
        </div>
      }
    </Grid>
  )
}
